import { useState } from 'react'
import { Icon } from '@iconify/react'

import s from './ShadeSelector.module.css'

const COLORS = [
  '#F43F5E',
  '#EF4444',
  '#F97316',
  '#EAB308',
  '#84CC16',
  '#22C55E',
  '#10B981',
  '#14B8A6',
  '#06B6D4',
  '#0EA5E9',
  '#3B82F6',
  '#6366F1',
  '#8B5CF6',
  '#D946EF',
  '#EC4899',
  '#1E293B',
]

type Props = {
  defaultColor: string
  selectColor: (val: string) => void
}

const ShadeSelector = ({ defaultColor, selectColor }: Props) => {
  const [shade, setShade] = useState('')

  return (
    <div className={s.container}>
      <div className={s.shadeContainer}>
        {COLORS.map(item => (
          <div
            key={item}
            className={s.shade}
            style={{ background: `${item}` }}
            role="none"
            onClick={() => {
              setShade(item)
              selectColor(item)
            }}
          >
            {(shade === item || defaultColor === item) && (
              <Icon icon="mdi:tick" className={s.tickMark} />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ShadeSelector
